import Swal from 'sweetalert2';
import { FETCH_PAGE, SUBMIT_PAGE, DELETE_PAGE, REFRESH_PAGE_DATATABLES } from './_types';
import { API_URL, API_RESPONSE_STATUS, API_RESPONSE_MESSAGE, API_RESPONSE } from '../constants/env';
import { authApiHeader } from '../helpers/apiHeader';

export const fetchPage = () => {
  return (dispatch) => {
    return fetch(`${API_URL}/page`, {
      method: 'GET',
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            dispatch({ type: FETCH_PAGE, result: response.data });
            break;

          case API_RESPONSE.FAILED:
          default:
            dispatch({ type: FETCH_PAGE, result: [] });
            Swal.fire('Fetch Page Failed', response[API_RESPONSE_MESSAGE], 'error');
        }
      });
  };
};

export const refreshPageDatatables = () => {
  return (dispatch) => {
    dispatch({ type: REFRESH_PAGE_DATATABLES });
  };
};

/**
 * @param data      title, content, url_slug, meta_title, meta_description, meta_keywords
 */
export const submitPage = (data) => {
  return (dispatch) => {
    return fetch(`${API_URL}/page`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Submit Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: SUBMIT_PAGE, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Submit Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshPageDatatables()))
      .then(() => dispatch(fetchPage()));
  };
};

/**
 * @param id
 * @param data      title, content, url_slug, meta_title, meta_description, meta_keywords
 */
export const updatePage = (id, data) => {
  return (dispatch) => {
    return fetch(`${API_URL}/page/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Submit Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: SUBMIT_PAGE, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Submit Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshPageDatatables()))
      .then(() => dispatch(fetchPage()));
  };
};

/**
 * @param id
 */
export const deletePage = (id) => {
  return (dispatch) => {
    return fetch(`${API_URL}/page/${id}`, {
      method: 'DELETE',
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Delete Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: DELETE_PAGE, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Delete Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshPageDatatables()))
      .then(() => dispatch(fetchPage()));
  };
};
